import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { connect } from "react-redux";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Button, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Grid from '@mui/material/Grid';
import ConfigModal from "../components/ConfigModal";
import { getFilesLoading,getConfigFilesData,getConfigDialogStatus, getControllersList} from "../selector/selectors";
import {  uploadConfigFile,loadConfigFileHistory} from "../api/managefileapi";
import ConfigFileHistoryItem from "../components/ConfigFileHistoryItem";
import LoaderComponent from "../components/LoaderComponent";
import SearchBoxComponent from "../components/SearchBoxComponent";
import { useDispatch } from "react-redux";
import { openConfigDialog,closeConfigDialog } from "../state/files/actions";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import AccessDeniedImg from '../assets/access_denied.png'
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux'
import { loadControllersList } from "../api/controllerpermissionsapi";

function ManageConfigFiles({
  isLoading,
  uploadConfigFile,
  startLoadingConfigFileHistory,
  configFileList,
  configDialogBoxStatus,
  controllersList
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const list     = useSelector((state) => state.userPermissionRoleData.userPermissionsRolesInfo);
  let roleAccessDenied = false;
  let userAccessDenied = false;
  list?.data?.rolePermissions?.map(rp => rp.key_name === 'manageConfigFiles' ? roleAccessDenied = true : roleAccessDenied);
  list?.data?.userPermissions?.map(up => up.key_name === 'manageConfigFiles' ? userAccessDenied = true : userAccessDenied);
  const [value, setValue]                   = useState('1');
  const [configFile, setConfigFile]         = useState('');
  const [isDefaultModal, setIsDefaultModal] = useState(false);
  const [isDefaultSerialModal, setIsDefaultSerialModal] = useState(false);
  const [filesData, setFilesData] = useState([]);
  //const [controllersData, setControllersData]           = useState(controllersList);
  const [searchText, setSearchText]   = useState('');
  const [configData, setConfigData]   = useState({
    version : '',
    releaseNotes:'',
    controllerId: 1,
    serialNumber:''
  });
  
  const handleChange = (event, newValue) => {
    if(newValue === '1'){
      startLoadingConfigFileHistory('','config');
    }  else if(newValue === '3'){
      startLoadingConfigFileHistory('','default');
    }
    setValue(newValue);
  };
  
  const handleClickOpenConfig = () => {
    document.activeElement.blur();
    dispatch(openConfigDialog());
  };

  const handleConfigFormData = () => {
    const formData = new FormData(); 
    let serialNumberFlag = false;
    if(isDefaultModal){
      formData.append('is_factory_default', 1);
      serialNumberFlag = false;
    }  else if(isDefaultSerialModal){
      formData.append('is_factory_default', 1);
      if(configData.serialNumber === ''){
        serialNumberFlag = true;
      } 
    } else {
      if(configData.serialNumber === ''){
        serialNumberFlag = true;
      } 
      formData.append('is_factory_default', 0);
    }
    if(configData.length === 0  || serialNumberFlag || configData.controllerId === '' || configData.releaseNotes === '' || configFile === ''){
      swal("Oops!", "Please fill required fields!", "error");
      return false;
    }
    formData.append('uploadedFile', configFile);
    
    Object.keys(configData).forEach(key => formData.append(key, configData[key]));
    uploadConfigFile(formData);
    if(configDialogBoxStatus === false){
      setConfigFile('');
      setIsDefaultModal(false);
      setIsDefaultSerialModal(false);
      setConfigData({
          version : '',
          releaseNotes:'',
          serialNumber:'',
          controllerId: 1
      });
      dispatch(closeConfigDialog());
    }
  }

  useEffect(() => {
    if(roleAccessDenied || userAccessDenied){
      startLoadingConfigFileHistory('','config');
      dispatch(loadControllersList());
    }
    dispatch(closeConfigDialog());
    // eslint-disable-next-line
  }, [startLoadingConfigFileHistory]);


  const handleChangeTextValue = (event,searchType) => {
    setSearchText(event.target.value);
    startLoadingConfigFileHistory(event.target.value,searchType);    
  };

  useEffect(() => {
    if(configDialogBoxStatus === false) {
      setConfigFile('');
      setIsDefaultModal(false);
      setIsDefaultSerialModal(false);
      setConfigData({
          version : '',
          releaseNotes:'',
          serialNumber:'',
          controllerId: 1,
      });
    }
  }, [configDialogBoxStatus,controllersList]);

  useEffect(() => {
    if (configFileList?.data) {
      setFilesData(configFileList?.data);
    }
  }, [configFileList]);

 
  return (
    <Box sx={{ flexGrow: 1 }} >
    { isLoading &&  (roleAccessDenied || userAccessDenied) ?  <LoaderComponent />: <></>}
      <Grid container >
        <TabContext value={value}>
          <Grid item xs={12} md={12} lg={12} >
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange} aria-label="">
                <Link className="tabingLinks" to="/web/firmware">Firmware</Link>
                <Tab label="Config File History" value="1" />
                <Link className="tabingLinks" to="/web/default-files">Default Configuration</Link>
                <Link className="tabingLinks" to="/web/event-logs">Event logs</Link>
            </TabList>
            </Box>
            <TabPanel value="1" sx={{p:0,pt:2}}>
              {(roleAccessDenied || userAccessDenied)  &&
                <>
                  <Grid container sx={{ paddingBottom: 1, display: 'flex', justifyContent: 'space-between' }}>
                    <Grid>
                      <SearchBoxComponent
                        handleChangeTextValue={(e) => handleChangeTextValue(e, 'config')}
                        label='Genset Serial Number' />
                    </Grid>
                    <Grid className="buttonSpacing">
                      <Button
                        variant="contained"
                        size="medium"
                        color="primary"
                        onClick={handleClickOpenConfig}
                      >
                        <CloudUploadIcon fontSize="medium" sx={{ paddingRight: 1 }} /> Upload
                      </Button>
                    </Grid>
                  </Grid>
                  <ConfigFileHistoryItem
                      list={filesData}
                      searchText={searchText}
                      searchType='config' 
                  />
                </>
              }
              {(roleAccessDenied === false && userAccessDenied === false)  &&
              <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                sx={{ minHeight: '80vh' }}
              >
                <img style={{maxWidth:'100%'}} alt="access_denied" src={AccessDeniedImg}  />
                <Typography sx={{paddingBottom:'10px'}} variant="h6">Access Denied</Typography>
                <Typography sx={{paddingBottom:'20px'}} variant="span">You do not have permission to view this page. </Typography>
                <Button onClick={(e)=>{navigate('/web/dashboard')}}  variant="contained">Dashboard</Button>
              </Grid>
            }
            </TabPanel>
            <TabPanel value="3" sx={{p:0,pt:2}}>
              <Grid container sx={{paddingBottom:1, display: 'flex', justifyContent: 'space-between'}}>
                <Grid>
                  <SearchBoxComponent 
                    handleChangeTextValue = {(e)=>handleChangeTextValue(e,'default')}
                    label='Genset Serial Number'
                  />
                </Grid>
                <Grid className="buttonSpacing">
                  <Button 
                    variant="contained"
                    size="medium"
                    color="primary"
                    onClick={()=> {
                      setIsDefaultSerialModal(true);
                      handleClickOpenConfig()
                    }}
                  >
                    <CloudUploadIcon fontSize="medium"  sx={{paddingRight:1}} /> Upload
                  </Button> 
                </Grid>
              </Grid>
              <ConfigFileHistoryItem 
                list={configFileList?.data}    
                searchText={searchText}
                searchType = 'config'  
              />
            </TabPanel>
          </Grid>
        </TabContext>   
        <ConfigModal
          open={configDialogBoxStatus}
          value={configData}
          setConfigData={setConfigData}
          configFile={configFile}
          setConfigFile={setConfigFile}
          handleConfigFormData={handleConfigFormData}
          isDefaultModal={isDefaultModal}     
          setIsDefaultModal={setIsDefaultModal}   
          isDefaultSerialModal={isDefaultSerialModal}     
          setIsDefaultSerialModal={setIsDefaultSerialModal}
          fileType={value}
          controllersList={controllersList}
        />   
      </Grid>
    </Box>
  );
}

const mapStateToProps = (state) => ({
  isLoading: getFilesLoading(state),   
  configFileList: getConfigFilesData(state),
  configDialogBoxStatus: getConfigDialogStatus(state),
  controllersList: getControllersList(state)
});

const mapDispatchToProps = (dispatch) => ({
  uploadConfigFile: (data)  => dispatch(uploadConfigFile(data)),
  startLoadingConfigFileHistory: (data,searchType)   => dispatch(loadConfigFileHistory(data,searchType)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageConfigFiles);

